export const LOADING_TITLES = "LOADING_TITLES";
export const SAVE_LOADING_TITLES = "SAVE_LOADING_TITLES";
export const GET_TITLES = "GET_TITLES";
export const FORM_FAIL = "FORM_FAIL";
export const FORM_FAIL_JSON = "FORM_FAIL_JSON";
export const TITLES_FAIL = "TITLES_FAIL";
export const LOADING_TITLES_BY_ID = "LOADING_TITLES_BY_ID";
export const GET_TITLES_BY_ID = "GET_TITLES_BY_ID";

